import { Caption } from '@heathmont/moon-core';
import styled from 'styled-components';
import ControlsChevronDown from '@/external/icons/ControlsChevronDown';

const ArrowStyled = styled(Caption)`
  display: flex;
  width: fit-content;
  justify-content: center;
  cursor: pointer;
`;

const SeeMore: FC = () => (
  <ArrowStyled as="span">
    <ControlsChevronDown fontSize={24} color="bulma.100" />
  </ArrowStyled>
);

export default SeeMore;
